import { MediaQueries, MediaSizeBreakpoint } from 'custom_hooks/useWindowSize';
import styled from 'styled-components';

export const BasePage = styled.section`
    box-sizing: border-box;
    padding: 5rem 2rem;
    width: calc(100vw - var(--navbar-width));

    @media ${MediaQueries.smallAndDown} {
        width: 100vw;
    }

    @media ${MediaQueries.largeAndUp} {
        // Large viewport: Layout remains the same as medium viewport, but the
        // grid padding becomes larger.
        padding: 5rem 5rem 7.5rem 5rem;
    }

    @media ${MediaQueries.xlargeAndUp} {
        padding: 5rem;
    }

    @media ${MediaQueries.xxlargeAndUp} {
        // XXL viewport: Layout remains the same, but the width becomes fixed
        // with the width of this breakpoint. The layout is centered along the
        // horizontal axis of the screen.
        max-width: ${MediaSizeBreakpoint.xxlarge}px;
        margin: 0 auto;
    }
`;
